__turbopack_context__.v({
  "givebutton": "bOX58q_givebutton",
  "givebuttoninverted": "bOX58q_givebuttoninverted",
});
